import { formatYearToSecondSn } from 'utils/date/format.util';

const generatePaymentsInvoiceNumber = ({ salonId, timestamp }) => `${salonId}-${formatYearToSecondSn(timestamp)}`;

export default generatePaymentsInvoiceNumber;
